import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-textarea',
  imports: [ReactiveFormsModule],
  templateUrl: './form-textarea.html',
})
export class FormTextarea {
  @Input() label!: string;
  @Input({ required: true }) control!: FormControl<unknown>;
  @Input() placeholder = '';

  isFieldInvalid(): boolean {
    return !!(
      this.control &&
      this.control.invalid &&
      (this.control.dirty || this.control.touched)
    );
  }
}
